import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../config/axiosConfig';

// createAsyncThunk handles the async logic
export const fetchUsers = createAsyncThunk('users/fetchUsers', async () => {
  const response = await api.get('/users');
  return response.data;
});